const doc = [({"da":({"js":({"nemoa":({"activities":({"elections":({"election":({"election":"Valg"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;